module.exports = __webpack_public_path__ + "img/favicon.4cd2b14.png";